import { BillingStateSchema } from '../zod-schemas/organization-subscription.schema'

/**
 * @param {Array<Object>} rows - Flat rows from `active_module_subscriptions`
 * @returns {z.infer<typeof BillingStateSchema>}
 */
export function groupBillingState(rows) {
    if (rows.length === 0) throw new Error('No billing data available')
    const [first] = rows

    const now = new Date()

    const subscriptionStatus = computeStatus({
        start: first.subscription_start,
        end: first.subscription_end,
        cancelled_at: first.cancelled_at,
        now,
    })

    const modules = rows.map((row) => {
        return {
            module_name: row.module_name,
            is_trial: row.is_trial,
            status: row.status,
            will_renew: !!row.will_renew,
            cancelled_at: row.module_cancelled_at
                ? new Date(row.module_cancelled_at)
                : null,
            created_at: new Date(row.subscription_start),
            start_date: new Date(row.module_start),
            end_date: new Date(row.module_end),
        }
    })

    const parsed = BillingStateSchema.parse({
        created_at: new Date(first.subscription_start),
        start_date: new Date(first.subscription_start),
        end_date: new Date(first.subscription_end),
        status: subscriptionStatus,
        billing_method: first.billing_method,
        billing_frequency: first.billing_frequency,
        subscription_modules: modules,
        is_trial: first.source === 'trial',
    })

    return parsed
}

/**
 * @param {{
 *   end: string | Date
 *   cancelled_at: string | null
 *   now: Date
 * }} args
 * @returns {'active' | 'cancelled' | 'expired'}
 */
function computeStatus({ end, cancelled_at, now }) {
    const endDate = new Date(end)

    if (cancelled_at) return 'cancelled'
    if (now > endDate) return 'expired'
    return 'active'
}
